import { Env } from '@environments/environment.types';

export const environment: Env = {
  production: true,
  prodMode: false,
  apiMarketPath: '/market-api',
  apiLivingPath: '/living-api',
  apiRemoveBgPath: '/remove-bg-api',
  apiVersion: {
    v0: '/v0',
    v1: '/v1',
    v2: '/v2',
  },
  sentry: {
    dsn: 'https://6fa9c455a76140b3b8450ddbd4b710e6@sentry.ugol.click/9',
    enabled: true,
  },
};
